import React, { FC } from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import { useDataHooks } from '@wix/data-hooks';

import './App.scss';
import { SubHeader } from '../SubHeader';
import { appDataHooks } from './App.dataHooks';
import { WidgetContainer } from '../WidgetContainer';

type AppProps = WithTranslation;

export const App: FC<AppProps> = () => {
  const { dataHooks } = useDataHooks(appDataHooks);

  return (
    <div>
      <SubHeader dataHook={dataHooks.subHeader({})} />
      <WidgetContainer dataHook={dataHooks.widgetContainer({})} />
    </div>
  );
};

export default withTranslation()(App);
